import { render, staticRenderFns } from "./ShHero.vue?vue&type=template&id=2137371a&scoped=true&"
import script from "./ShHero.vue?vue&type=script&lang=js&"
export * from "./ShHero.vue?vue&type=script&lang=js&"
import style0 from "./ShHero.vue?vue&type=style&index=0&id=2137371a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137371a",
  null
  
)

export default component.exports